import { render, staticRenderFns } from "./select_commission_type.vue?vue&type=template&id=a8db2dfa&scoped=true"
import script from "./select_commission_type.vue?vue&type=script&lang=js"
export * from "./select_commission_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8db2dfa",
  null
  
)

export default component.exports